(function($) {

    $(document).ready(function() {
        $("div[id^='links']").each(function(i) {
          this.onclick = function (event) {
              event = event || window.event;
              var target = event.target || event.srcElement,
                  link = target.src ? target.parentNode : target,
                  options = {index: link, event: event},
                  links = this.getElementsByTagName('a');
              blueimp.Gallery(links, options);

          };
        });


        var str = '<div id="blueimp-gallery" class="blueimp-gallery blueimp-gallery blueimp-gallery-controls">';
          str += '<div class="slides"></div>';
          str += '<h3 class="title"></h3>';
          str += '<a class="prev">‹</a>';
          str += '<a class="next">›</a>';
          str += '<a class="close">×</a>';
          str += '<a class="play-pause"></a>';
          str += '<ol class="indicator"></ol>';
          str += '</div>';

        $('body').prepend(str);
    });

})( jQuery );
